import { graphql } from "@cappelendamm/crystallize-types/pim/gql";
export const fetchSubscriptionVariantsBySku = async ({ sku }, { client }) => {
    const data = await client.pim.request(graphql(`
      query SubscriptionVariants(
        $language: String!
        $skus: [String!]
        $tenantId: ID!
      ) {
        product {
          getVariants(language: $language, skus: $skus, tenantId: $tenantId) {
            product {
              variants {
                sku
              }
            }
          }
        }
      }
    `), {
        language: "no-nb",
        skus: [sku],
        tenantId: client.tenantId,
    });
    if (!data.product) {
        throw new Error(`Subscription item sku: ${sku} not found!`);
    }
    const variants = data.product.getVariants?.[0]?.product?.variants;
    if (!variants) {
        throw new Error(`Subscription item sku: ${sku} has no variants!`);
    }
    return variants.map((item) => item.sku);
};
